<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :loading="isLoading"
  >
    <template #layoutContent>
      <Loader :isLoading="isLoading">
        <ExpenseForm
            :is-edit="isEdit"
            :expense="expense"
            :submit-form="!isEdit ? createExpense : updateExpense"
            :submitting="submitting"
        />
      </Loader>
    </template>
  </SubLayout>
</template>

<script setup>

import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed, onMounted, ref, watch} from "vue";
import Loader from "@/components/Loader";
import ExpenseForm from "@/Modules/Financial/components/Expense/ExpenseForm.vue";
import {createFormData} from "@/mixins/Helpers";

const route = useRoute()
const router = useRouter()
const store = useStore()
const title = ref("breadcrumbs.expense.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.expense.list',
    route: 'expenses',
    params: {}
  },
  {
    name: route.params.id ? 'breadcrumbs.expense.edit' : 'breadcrumbs.expense.new',
    route: route.params.id ? 'expenses-edit' : 'expenses-create',
    params: route.params.id ? { id: route.params.id } : { type: route.params.type }
  }
])

const isLoading = ref(true)
const submitting = ref(false)

const expense = ref({
  id: null,
  title: '',
  type_id: route.params.typeId || '',
  countriesFees: [{
    country: '',
    fees: [{
      date: '',
      amount: 0,
      reason_id: '',
      invoices: []
    }]
  }],
  fees: [{
    id: '',
    date: '',
    amount: 0,
    reason_id: '',
    invoices: []
  }]
})

const isEdit = computed(() => !!route.params.id)
const currentExpense = computed(() => store.getters['expenses/currentExpense'])
const contacts = computed(() => store.getters['contacts/getContacts'])

watch(() => currentExpense.value, (newValue) => {
  if(newValue.id && route.params.id) {
    expense.value.id = newValue.id
    expense.value.title = newValue.title
    expense.value.type_id = newValue.type?.id
    expense.value.type = newValue.type?.title
    expense.value.feesToDelete = []
    expense.value.fees = []
    expense.value.fees = newValue.fees?.map(el => ({
      id: el.id,
      date: el.date,
      amount: el.amount,
      reason_id: el?.reason?.id,
      invoices: el.fee_with_invoice_url?.map(img => img),
      removes: []
    }))
  } else {
  }

}, {immediate: true})

const createExpense = () => {
  submitting.value = true
  const formData = createFormData(expense.value)
  store.dispatch('expenses/createExpense', formData)
      .then((response) => {
        window.toastr['success'](i18n.global.t('notification.expense_created'))
        router.push({ name: 'expenses-view', params: { id: response.data.expense.id } })
      })
      .catch(err => {
      }).finally(() => submitting.value = false)
}

const updateExpense = () => {
  submitting.value = true
  expense.value?.fees?.forEach(fee => {
    fee.invoices = fee.invoices?.filter(el => el instanceof File) || [];
  });
  const formData = createFormData(expense.value)
  formData.append('_method', 'PATCH')
  store.dispatch('expenses/updateExpense', {id: expense.value.id, data: formData})
      .then((response) => {
        window.toastr['success'](i18n.global.t('notification.expense_updated'))
        router.push({ name: 'expenses-view', params: { id: response.data.id } })
      })
      .catch(err => {
      }).finally(() => submitting.value = false)
}

const loadCurrentExpense = async () => {
  if(route.params.id){
    await store.dispatch('expenses/getExpensesById', route.params.id)
  }
}

function loadData() {
  Promise.all([
    loadCurrentExpense()
  ]).finally(() => {
    isLoading.value = false
  })
}

onMounted(() => {
  loadData()
})

</script>

<style scoped>

</style>
